import { render, staticRenderFns } from "./Theme2Section1.vue?vue&type=template&id=2972ed6e&scoped=true&"
import script from "./Theme2Section1.vue?vue&type=script&lang=js&"
export * from "./Theme2Section1.vue?vue&type=script&lang=js&"
import style0 from "./Theme2Section1.vue?vue&type=style&index=0&id=2972ed6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972ed6e",
  null
  
)

export default component.exports